module.exports = __webpack_public_path__ + "static/social-card.8bccb721.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/social-card.png
// module id = 1001
// module chunks = 114276838955818